module.exports = __webpack_public_path__ + "img/search-icon.127ce98d.png";